import RouteConfig from "./models/RouteConfig";
import SignIn from "./landing-pages/SignIn";
import Index from "./landing-pages/Index";
import Register from "./landing-pages/Register";
import VerifyAccount from "./landing-pages/VerifyAccount";
import ChangePassword from "./landing-pages/ChangePassword";
import Home from "./landing-pages/home/Home";
import InterviewerDashboard from "./landing-pages/Interviewer/InterviewerDashboard";
import InterviewerProfile from "./landing-pages/Interviewer/InterviewerProfile";
import InterviewerSchedule from "./landing-pages/Interviewer/InterviewerSchedule";
import ReferFriend from "./landing-pages/Interviewer/ReferFriend";
import PickUpSchedule from "./landing-pages/Interviewer/PickUpSchedule";
import InterviewerPersonalInfo from "./landing-pages/Interviewer/InterviewerPersonalInfo";
import CandidateDashboard from "./landing-pages/candidate/CandidateDashboard";
import CandidateProfile from "./landing-pages/candidate/CandidateProfile";
import ScheduleInterview from "./landing-pages/candidate/ScheduleInterview";
import RateInterview from "./landing-pages/Interviewer/RateInterview";
import CandidateJobs from "./landing-pages/candidate/CandidateJobs";
import CandidateAccess from "./landing-pages/candidate/CandidateAccess";
import CompanyDashboard from "./landing-pages/company/CompanyDashboard";
import Department from "./landing-pages/company/Department";
import Designation from "./landing-pages/company/Designation";
import SubUser from "./landing-pages/company/SubUser";
import Vendor from "./landing-pages/company/Vendor";
import VendorSubUser from "./landing-pages/company/VendorSubUser";
import VendorDashboard from "./landing-pages/company/VendorDashboard";
import VendorSubUserDashboard from "./landing-pages/company/VendorSubUserDashboard";
import ClientRecruiterDashboard from "./landing-pages/company/ClientRecruiterDashboard";
import AllJobPostingsDashboard from "./landing-pages/admin/AllJobPostingsDashboard";
import JobPosting from "./landing-pages/company/JobPosting";
import JobPostingInterviewProcess from "./landing-pages/company/JobPostingInterviewProcess";
import AddProfiles from "./landing-pages/company/AddProfiles";
import RelatedProfiles from "./landing-pages/company/RelatedProfiles";
import ShortlistedProfiles from "./landing-pages/company/ShortlistedProfiles";
import AppliedCandidates from "./landing-pages/company/AppliedCandidates";
import AdminDashboard from "./landing-pages/admin/AdminDashboard";
import AdminUser from "./landing-pages/admin/AdminUser";
import PrimarySkill from "./landing-pages/admin/skill/PrimarySkill";
import SecondarySkill from "./landing-pages/admin/skill/SecondarySkill";
import EditRating from "./landing-pages/admin/interviews/EditRating";
import Interviews from "./landing-pages/admin/interviews/Interviews";
import ByPassPaymentGateway from "./landing-pages/admin/candidate/ByPassPaymentGateway";
import CandidatePassword from "./landing-pages/admin/candidate/CandidatePassword";
import RegisteredCandidates from "./landing-pages/admin/candidate/RegisteredCandidates";
import InterviewerSchedules from "./landing-pages/admin/interviewer/InterviewerSchedules";
import RegisteredInterviewers from "./landing-pages/admin/interviewer/RegisteredInterviewers";
import AdminAddProfiles from "./landing-pages/admin/company/AdminAddProfiles";
import AdminAllProfiles from "./landing-pages/admin/company/AdminAllProfiles";
import AdminPostRequirement from "./landing-pages/admin/company/AdminPostRequirement";
import AdminViewRating from "./landing-pages/admin/company/AdminViewRating";
import CompanyOnBoard from "./landing-pages/admin/company/CompanyOnBoard";
import CompanyProfilesDashboard from "./landing-pages/admin/company/CompanyProfilesDashboard";
import ReleaseCandidates from "./landing-pages/admin/company/ReleaseCandidates";
import TodaysFollowups from "./landing-pages/admin/candidate/TodaysFollowups";
import AllProfiles from "./landing-pages/company/AllProfiles";
import Escalations from "./landing-pages/admin/company/Escalations";
import CompanyInterviewer from "./landing-pages/company/CompanyInterviewer";
import CompanyProfile from "./landing-pages/company/CompanyProfile";
import { RoleEnum } from "./models/enums/RoleEnum";
import Testimonials from "./landing-pages/outer-pages/Testimonials";
import FAQ from "./landing-pages/outer-pages/FAQ";
import AboutUs from "./landing-pages/outer-pages/AboutUs";
import Privacy from "./landing-pages/outer-pages/Privacy";
import Blogs from "./landing-pages/outer-pages/Blogs";
import Sitemap from "./landing-pages/outer-pages/SiteMap";
import AllJobPostings from "./landing-pages/company/AllJobPostings";
import City from "./landing-pages/admin/city/City";
import Domain from "./landing-pages/company/Domain";
import BlankPage from "./components/layout/BlankPage";

const routes: RouteConfig[] = [
    {
        path: "/",
        component: Home,
        protected: true,
        exact: true,
    },
    {
        path: "/index",
        component: Index,
        protected: false,
    },
    {
        path: "/testimonials",
        component: Testimonials,
        protected: false,
    },
    {
        path: "/faqs",
        component: FAQ,
        protected: false,
    },
    {
        path: "/about-us",
        component: AboutUs,
        protected: false,
    },
    {
        path: "/privacy-policy",
        component: Privacy,
        protected: false,
    },
    {
        path: "/blogs",
        component: Blogs,
        protected: false,
    },
    {
        path: "/site-map",
        component: Sitemap,
        protected: false,
    },
    {
        path: "/login",
        component: SignIn,
        protected: false,
    },
    {
        path: "/register/:type",
        component: Register,
        protected: false,
    },
    {
        path: "/verifyaccount/:verificationCode",
        component: VerifyAccount,
        protected: false,
    },
    {
        path: "/changepassword",
        component: ChangePassword,
        protected: false,
    },
    {
        path: "/interviewer-dashboard",
        component: InterviewerDashboard,
        protected: true,
        roles: [Number(RoleEnum.Interviewer)],
    },
    {
        path: "/interviewer-profile",
        component: InterviewerProfile,
        protected: true,
        roles: [Number(RoleEnum.Interviewer)],
    },
    {
        path: "/interviewer-personal-info",
        component: InterviewerPersonalInfo,
        protected: true,
        roles: [Number(RoleEnum.Interviewer)],
    },
    {
        path: "/interviewer-schedule",
        component: InterviewerSchedule,
        protected: true,
        roles: [Number(RoleEnum.Interviewer)],
    },
    {
        path: "/refer-friend",
        component: ReferFriend,
        protected: true,
        roles: [Number(RoleEnum.Interviewer)],
    },
    {
        path: "/pickup-schedule",
        component: PickUpSchedule,
        protected: true,
        roles: [Number(RoleEnum.Interviewer)],
    },
    {
        path: "/candidate-dashboard",
        component: CandidateDashboard,
        protected: true,
        roles: [Number(RoleEnum.Candidate)],
    },
    {
        path: "/candidate-profile",
        component: CandidateProfile,
        protected: true,
        roles: [Number(RoleEnum.Candidate)],
    },
    {
        path: "/schedule-interview",
        component: ScheduleInterview,
        protected: true,
        roles: [Number(RoleEnum.Candidate)],
    },
    {
        path: "/rate-interview/:interviewId",
        component: RateInterview,
        protected: true,
        roles: [Number(RoleEnum.Interviewer)],
    },
    {
        path: "/candidate-jobs",
        component: CandidateJobs,
        protected: true,
        roles: [Number(RoleEnum.Candidate)],
    },
    {
        path: "/candidate-access",
        component: CandidateAccess,
        protected: true,
        roles: [Number(RoleEnum.Candidate)],
    },
    {
        path: "/company-dashboard",
        component: CompanyDashboard,
        protected: true,
        roles: [Number(RoleEnum.ClientAdmin)],
    },
    {
        path: "/department",
        component: Department,
        protected: true,
        roles: [Number(RoleEnum.ClientAdmin)],
    },
    {
        path: "/designation",
        component: Designation,
        protected: true,
        roles: [Number(RoleEnum.ClientAdmin), Number(RoleEnum.ClientRecruiter), Number(RoleEnum.ClientLead)],
    },
    {
        path: "/sub-user",
        component: SubUser,
        protected: true,
        roles: [Number(RoleEnum.ClientAdmin)],
    },
    {
        path: "/vendor",
        component: Vendor,
        protected: true,
        roles: [Number(RoleEnum.ClientAdmin)],
    },
    {
        path: "/vendor-sub-user",
        component: VendorSubUser,
        protected: true,
        roles: [Number(RoleEnum.Vendor)],
    },
    {
        path: "/recruiter-dashboard",
        component: ClientRecruiterDashboard,
        protected: true,
        roles: [Number(RoleEnum.ClientRecruiter), Number(RoleEnum.ClientLead)],
    },
    {
        path: "/vendor-dashboard",
        component: VendorDashboard,
        protected: true,
        roles: [Number(RoleEnum.Vendor)],
    },
    {
        path: "/vendor-recruiter-dashboard",
        component: VendorSubUserDashboard,
        protected: true,
        roles: [Number(RoleEnum.VendorRecruiter)],
    },
    {
        path: "/job-posting",
        component: JobPosting,
        protected: true,
        roles: [Number(RoleEnum.ClientRecruiter), Number(RoleEnum.ClientLead), Number(RoleEnum.Administrator), Number(RoleEnum.IAIRecruiter), Number(RoleEnum.IAIAccountManager)],
    },
    {
        path: "/interview-process/:requirementId",
        component: JobPostingInterviewProcess,
        protected: true,
        roles: [Number(RoleEnum.ClientRecruiter), Number(RoleEnum.ClientLead), Number(RoleEnum.Administrator), Number(RoleEnum.IAIRecruiter), Number(RoleEnum.IAIAccountManager)],
    },
    {
        path: "/add-profiles/:requirementId",
        component: AddProfiles,
        protected: true,
        roles: [Number(RoleEnum.ClientRecruiter), Number(RoleEnum.VendorRecruiter)],
    },
    {
        path: "/related-profiles/:requirementId",
        component: RelatedProfiles,
        protected: true,
        roles: [Number(RoleEnum.ClientRecruiter), Number(RoleEnum.ClientLead), Number(RoleEnum.VendorRecruiter), Number(RoleEnum.Vendor)],
    },
    {
        path: "/shortlisted-profiles/:requirementId",
        component: ShortlistedProfiles,
        protected: true,
        roles: [Number(RoleEnum.ClientRecruiter), Number(RoleEnum.ClientLead), Number(RoleEnum.VendorRecruiter), Number(RoleEnum.Vendor)],
    },
    {
        path: "/applied-candidates/:requirementId",
        component: AppliedCandidates,
        protected: true,
        roles: [Number(RoleEnum.ClientRecruiter), Number(RoleEnum.ClientLead), Number(RoleEnum.VendorRecruiter), Number(RoleEnum.Vendor)],
    },
    {
        path: "/admin-dashboard",
        component: AdminDashboard,
        protected: true,
        roles: [Number(RoleEnum.Administrator), Number(RoleEnum.IAIRecruiter), Number(RoleEnum.PanelManagement), Number(RoleEnum.IAIAccountManager)],
    },
    {
        path: "/admin-user",
        component: AdminUser,
        protected: true,
        roles: [Number(RoleEnum.Administrator)],
    },
    {
        path: "/primary-skill",
        component: PrimarySkill,
        protected: true,
        roles: [Number(RoleEnum.Administrator), Number(RoleEnum.PanelManagement)],
    },
    {
        path: "/secondary-skill",
        component: SecondarySkill,
        protected: true,
        roles: [Number(RoleEnum.Administrator), Number(RoleEnum.PanelManagement)],
    },
    {
        path: "/edit-rating",
        component: EditRating,
        protected: true,
        roles: [Number(RoleEnum.Administrator)],
    },
    {
        path: "/interviews",
        component: Interviews,
        protected: true,
        roles: [Number(RoleEnum.Administrator), Number(RoleEnum.IAIRecruiter), Number(RoleEnum.PanelManagement)],
    },
    {
        path: "/by-pass-payment-gateway",
        component: ByPassPaymentGateway,
        protected: true,
        roles: [Number(RoleEnum.Administrator), Number(RoleEnum.IAIRecruiter), Number(RoleEnum.PanelManagement)],
    },
    {
        path: "/candidate-password",
        component: CandidatePassword,
        protected: true,
        roles: [Number(RoleEnum.Administrator), Number(RoleEnum.IAIRecruiter)],
    },
    {
        path: "/registered-candidates",
        component: RegisteredCandidates,
        protected: true,
        roles: [Number(RoleEnum.Administrator), Number(RoleEnum.IAIRecruiter), Number(RoleEnum.PanelManagement)],
    },
    {
        path: "/interviewer-schedules",
        component: InterviewerSchedules,
        protected: true,
        roles: [Number(RoleEnum.Administrator), Number(RoleEnum.PanelManagement)],
    },
    {
        path: "/registered-interviewers",
        component: RegisteredInterviewers,
        protected: true,
        roles: [Number(RoleEnum.Administrator), Number(RoleEnum.PanelManagement)],
    },
    {
        path: "/admin-add-profiles",
        component: AdminAddProfiles,
        protected: true,
        roles: [Number(RoleEnum.Administrator), Number(RoleEnum.IAIRecruiter), Number(RoleEnum.IAIAccountManager)],
    },
    {
        path: "/admin-all-profiles",
        component: AdminAllProfiles,
        protected: true,
        roles: [Number(RoleEnum.Administrator), Number(RoleEnum.IAIRecruiter), Number(RoleEnum.IAIAccountManager)],
    },
    {
        path: "/admin-post-requirement",
        component: AdminPostRequirement,
        protected: true,
        roles: [Number(RoleEnum.Administrator), Number(RoleEnum.IAIRecruiter), Number(RoleEnum.IAIAccountManager)],
    },
    {
        path: "/admin-view-rating",
        component: AdminViewRating,
        protected: true,
        roles: [Number(RoleEnum.Administrator), Number(RoleEnum.IAIRecruiter), Number(RoleEnum.IAIAccountManager)],
    },
    {
        path: "/company-on-board",
        component: CompanyOnBoard,
        protected: true,
        roles: [Number(RoleEnum.Administrator)],
    },
    {
        path: "/company-profiles-dashboard",
        component: CompanyProfilesDashboard,
        protected: true,
        roles: [Number(RoleEnum.Administrator), Number(RoleEnum.IAIRecruiter), Number(RoleEnum.IAIAccountManager)],
    },
    {
        path: "/release-candidates",
        component: ReleaseCandidates,
        protected: true,
        roles: [Number(RoleEnum.Administrator), Number(RoleEnum.IAIRecruiter)],
    },
    {
        path: "/todays-follow-ups",
        component: TodaysFollowups,
        protected: true,
        roles: [Number(RoleEnum.Administrator), Number(RoleEnum.IAIRecruiter)],
    },
    {
        path: "/all-profiles",
        component: AllProfiles,
        protected: true,
        roles: [Number(RoleEnum.Administrator), Number(RoleEnum.IAIRecruiter), Number(RoleEnum.IAIAccountManager), Number(RoleEnum.ClientAdmin), Number(RoleEnum.ClientLead), Number(RoleEnum.ClientRecruiter), Number(RoleEnum.Vendor), Number(RoleEnum.VendorRecruiter)],
    },
    {
        path: "/client-escalations",
        component: Escalations,
        protected: true,
        roles: [Number(RoleEnum.IAIAccountManager), Number(RoleEnum.IAIRecruiter), Number(RoleEnum.Administrator)],
    },
    {
        path: "/company-panels",
        component: CompanyInterviewer,
        protected: true,
        roles: [Number(RoleEnum.Administrator), Number(RoleEnum.PanelManagement), Number(RoleEnum.ClientAdmin), Number(RoleEnum.ClientLead), Number(RoleEnum.ClientRecruiter)],
    },
    {
        path: "/company-profile",
        component: CompanyProfile,
        protected: true,
        roles: [Number(RoleEnum.ClientAdmin)],
    },
    {
        path: "/all-job-postings",
        component: AllJobPostings,
        protected: true,
        roles: [Number(RoleEnum.ClientAdmin), Number(RoleEnum.ClientLead), Number(RoleEnum.ClientRecruiter), Number(RoleEnum.Vendor), Number(RoleEnum.VendorRecruiter)],
    },
    {
        path: "/admin-job-postings-dashboard",
        component: AllJobPostingsDashboard,
        protected: true,
        roles: [Number(RoleEnum.Administrator), Number(RoleEnum.IAIRecruiter), Number(RoleEnum.IAIAccountManager)],
    },
    {
        path: "/city",
        component: City,
        protected: true,
        roles: [Number(RoleEnum.Administrator)],
    },
    {
        path: "/domain",
        component: Domain,
        protected: true,
        roles: [Number(RoleEnum.ClientAdmin), Number(RoleEnum.ClientLead), Number(RoleEnum.ClientRecruiter)],
    },
    {
        path: "/blankpage",
        component: BlankPage,
        protected: true,
    },
];
export default routes;